import React, { useEffect, useRef } from "react";
import { RADHADAY } from "../PanaCharts/Chart.config";
import { redJodi } from "./Chart.config";

/* ---------- Skeleton Row Component ---------- */
const SkeletonRow = ({ colCount }) => (
  <tr>
    {Array.from({ length: colCount }).map((_, i) => (
      <td key={i} className="cc">
        <div className="tw-animate-pulse tw-h-8 tw-bg-gray-200 tw-rounded-md tw-m-1" />
      </td>
    ))}
  </tr>
);

/* ---------- Render a single cell ---------- */
const renderCell = (value) => {
  const safeValue = value ?? "-";
  const isRed = redJodi.map((j) => parseInt(j)).includes(parseInt(safeValue) || 0);
  return (
    <div className="kalyan-chart-number-black">
      <span className={`cp ${isRed ? "text-danger" : "text-dark"}`}>{safeValue}</span>
    </div>
  );
};

const ShreeDay = ({ chartData }) => {
  const tableEndRef = useRef(null);
  const colCount = 7; // MON-SUN

  const dynamicLoading = !chartData || chartData.length === 0;

  // Auto-scroll to bottom when chartData updates
  useEffect(() => {
    tableEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [chartData]);

  return (
    <div className="tw-overflow-x-auto">
      <table className="table fw-bold tw-w-full" border="collapse">
        <thead>
           <tr className="tw-text-center">
            <th className="ch">MON</th>
            <th className="ch">TUE</th>
            <th className="ch">WED</th>
            <th className="ch">THU</th>
            <th className="ch">FRI</th>
            <th className="ch">SAT</th>
            <th className="ch">SUN</th>
          </tr>
        </thead>
        <tbody>
          {/* ---------- STATIC RADHADAY OR SKELETON ---------- */}
          {Object.entries(RADHADAY).map(([week, days], index) => (
                <tr key={index}>
                  {Object.entries(days).map(([day, values], id) => {
                    const displayValue = Array.isArray(values) && values.length > 1 ? values[1] : values?.[0] ?? "-";
                    return (
                      <td key={id} className="cc">
                        {renderCell(displayValue)}
                      </td>
                    );
                  })}
                </tr>
              ))}

          {/* ---------- DYNAMIC chartData OR SKELETON ---------- */}
          {dynamicLoading
            ? Array.from({ length: 3 }).map((_, i) => <SkeletonRow key={`dynamic-skel-${i}`} colCount={colCount} />)
            : chartData.map((item1) => (
                <tr key={item1.id}>
                  {item1.data.map((nestedItem) => {
                    const family0 = nestedItem.relatedData?.[0]?.winningDigitFamily ?? "";
                    const family1 = nestedItem.relatedData?.[1]?.winningDigitFamily ?? "";
                    const combinedValue = `${family0}${family1}`;
                    return (
                      <td key={nestedItem.id} className="cc">
                        {renderCell(combinedValue)}
                      </td>
                    );
                  })}
                </tr>
              ))}

          {/* Dummy row for scroll */}
          <tr ref={tableEndRef} />
        </tbody>
      </table>
    </div>
  );
};

export default ShreeDay;
